import { render, staticRenderFns } from "./RootNodeConfig.vue?vue&type=template&id=4328e914&scoped=true"
import script from "./RootNodeConfig.vue?vue&type=script&lang=js"
export * from "./RootNodeConfig.vue?vue&type=script&lang=js"
import style0 from "./RootNodeConfig.vue?vue&type=style&index=0&id=4328e914&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4328e914",
  null
  
)

export default component.exports